import { selectCompanyId } from "../helpers/selector.helpers"
import { useAppSelector } from "./useRedux"

export const useEditorSettings = () => {
    const settings = useAppSelector((state) => state.editor.value.settings)
    const companyId = useAppSelector(selectCompanyId)

    return { ...settings, companyId }
}
